import React, { Suspense } from 'react';
import { retry } from '../../Utility/loadingChunkErrorHandler';

import './tourembed.css';

const TourFull = React.lazy(() =>
  retry(() =>
    import(
      /* webpackChunkName: "tourfull" */ '../TourFullView/TourFullView.container'
    )
  )
);

const TourEmbed = (props) => {
  return (
    <Suspense fallback={<div />}>
      <TourFull {...props} />
    </Suspense>
  );
};

export default TourEmbed;
